import { render } from "./NBURatesCreepJS.vue?vue&type=template&id=ed735f06&scoped=true&ts=true"
import script from "./NBURatesCreepJS.vue?vue&type=script&lang=ts"
export * from "./NBURatesCreepJS.vue?vue&type=script&lang=ts"

import "./NBURatesCreepJS.vue?vue&type=style&index=0&id=ed735f06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed735f06"]])

export default __exports__